import { StyledButton } from './InputButton.styled';

const InputButton = ({ selected, width, onClick, disabled, children }) => (
  <StyledButton $selected={selected} $width={width} $disabled={disabled} onClick={onClick} disabled={disabled}>
    {children}
  </StyledButton>
);

export default InputButton;
